import { IPrAffiliate } from "@/models/IPrAffiliate";
import { BaseRepository } from "@/repositories/BaseRepository";

class PrAffiliateRepository extends BaseRepository<IPrAffiliate> {
    constructor() {
        super("/prAffiliates");
    }
}

const prAffiliateRepository = new PrAffiliateRepository();

export { PrAffiliateRepository, prAffiliateRepository };
